export function getPromiseWithResolver(){
	let resolver;
	const promise = new Promise(r => {resolver = r});
	return [resolver, promise];
}
